<template>
	<div>
    <div class="mon-title">订单号：{{orderinfo.ordersn}}</div>
		<steps :active="statuscount">
      <step>等待买家付款</step>
      <step>等待卖家发货</step>
      <step>等待卖家确认收货</step>
      <step>交易成功</step>
    </steps>
    <div class="money" v-for="(item,index) in productinfo" :key="index">
      <card
        :num="item.num"
        :price="item.price"
        :desc="'规格：'+item.sku"  
        :title="item.store_name"
        :thumb="item.image"
      />
    </div>
    <contact-card
      type="edit"
      :name="orderinfo.real_name"
      :tel="orderinfo.phone"
      :editable="false"
    />
    <submit-bar
      :price="orderinfo.total_price*100"
      button-text="提交订单"
      tip-icon="info-o"
      :tip="'地址：'+orderinfo.address"
      @submit="onSubmit"
    >
      <Button type="info" @click="bind">绑定用户</Button>
    </submit-bar>
	</div>
</template>
<script>
  import {wxInfo,morderDetail,mpayOrder,mbindUser} from "@/libs/api";
  import { wechatLoginUrl,setStorage, getStorage,removeStorage} from "@/libs/utils";
  import { onBridgeReady } from "@/libs/wechat";
  import { Step, Steps, Card,SubmitBar,ContactCard, ContactList, ContactEdit,Button,Toast } from 'vant';
  import moment from "moment";

  export default {
    name: "money",
    components: {
      Step, Steps, Card, SubmitBar,ContactCard, ContactList, ContactEdit,Button,Toast
    },
    filters: {
      formattime: date => {
        return moment(date * 1000).format("YY-MM-DD HH:mm");
      }
    },
    data() {
      return {
      	list:{},
      	code:'',
        order_id:'',
      	statuscount:0,
      	productinfo:[],
        orderinfo:{},
        openid:''
      }
    },
    methods: {
    	detail(){
    		morderDetail({
    			ordersn:this.order_id    			
    		}).then(res=>{
    			if(res.statusCode==200){
    				this.statuscount = res.data.statuscount
            this.productinfo = res.data.productinfo
    				this.orderinfo = res.data.orderinfo
    			}
    		})
    	},
      onSubmit(){
        mpayOrder({
          ordersn:this.order_id,
          openid:this.openid
        }).then(res=>{
          if(res.statusCode==200){
            let shipment = res.data.payJumpUrl;
            let payurl = window.location.href;
            shipment.jumpurl = encodeURIComponent(payurl);
            let jumpurl = "https://store.moveclub.cn/wechatpays.php?info=" + encodeURIComponent(JSON.stringify(shipment));
            window.location.replace(jumpurl);
          }
        })
      },
      bind(){
        mbindUser({
          ordersn:this.order_id,
          openid:this.openid
        }).then(res=>{
          if(res.statusCode==200){
            this.$toast('绑定成功！');
          }
          
        })
      }
    },
    mounted() {
      this.$nextTick(() => {
        let order_id = this.$route.query.order_id
        if(order_id){
          this.order_id = order_id;
          window.localStorage.setItem('order_id', order_id);
        }else{
          this.order_id = window.localStorage.getItem('order_id');
        } 
        let userinfo = getStorage('userInfo');
        let moneypay = getStorage('moneypay');
        if(!moneypay){
          removeStorage('userInfo')
          this.$router.replace({ name: "login" });
        } else{
          this.openid = userinfo.openid 
        }
        this.detail();
      })
    }
  };
</script>

<style lang="less">
.mon-title{
    background: #FFFFFF;
    margin-bottom: 10px;
    font-size: 20px;
    color: #333333;
}
.money{
  margin: 10px 0;
}
.van-card {
  background-color:#ffffff;
}
</style>